var items = {
  "block.minecraft.air": "aer",
  "block.minecraft.stone": "piatră",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit șlefuit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "diorit șlefuit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "andezit șlefuit",
  "block.minecraft.grass_block": "bloc de iarbă",
  "block.minecraft.dirt": "pământ",
  "block.minecraft.coarse_dirt": "pământ pietros",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "niliu stacojiu",
  "block.minecraft.warped_nylium": "niliu deformat",
  "block.minecraft.cobblestone": "pietruială",
  "block.minecraft.oak_planks": "scânduri de stejar",
  "block.minecraft.spruce_planks": "scânduri de molid",
  "block.minecraft.birch_planks": "scânduri de mesteacăn",
  "block.minecraft.jungle_planks": "scânduri de junglă",
  "block.minecraft.acacia_planks": "scânduri de salcâm",
  "block.minecraft.dark_oak_planks": "scânduri de stejar negru",
  "block.minecraft.crimson_planks": "scânduri stacojii",
  "block.minecraft.warped_planks": "scânduri deformate",
  "block.minecraft.oak_sapling": "puiet de stejar",
  "block.minecraft.spruce_sapling": "puiet de molid",
  "block.minecraft.birch_sapling": "puiet de mesteacăn",
  "block.minecraft.jungle_sapling": "puiet de junglă",
  "block.minecraft.acacia_sapling": "puiet de salcâm",
  "block.minecraft.dark_oak_sapling": "puiet de stejar negru",
  "block.minecraft.bedrock": "rocă de bază",
  "block.minecraft.sand": "nisip",
  "block.minecraft.red_sand": "nisip roșu",
  "block.minecraft.gravel": "pietriș",
  "block.minecraft.gold_ore": "minereu de aur",
  "block.minecraft.iron_ore": "minereu de fier",
  "block.minecraft.coal_ore": "minereu de cărbune",
  "block.minecraft.nether_gold_ore": "minereu de aur din nether",
  "block.minecraft.oak_log": "buștean de stejar",
  "block.minecraft.spruce_log": "buștean de molid",
  "block.minecraft.birch_log": "buștean de mesteacăn",
  "block.minecraft.jungle_log": "buștean de junglă",
  "block.minecraft.acacia_log": "buștean de salcâm",
  "block.minecraft.dark_oak_log": "buștean de stejar negru",
  "block.minecraft.crimson_stem": "tulpină stacojie",
  "block.minecraft.warped_stem": "tulpină deformată",
  "block.minecraft.stripped_oak_log": "buștean de stejar decojit",
  "block.minecraft.stripped_spruce_log": "buștean de molid decojit",
  "block.minecraft.stripped_birch_log": "buștean de mesteacăn decojit",
  "block.minecraft.stripped_jungle_log": "buștean de junglă decojit",
  "block.minecraft.stripped_acacia_log": "buștean de salcâm decojit",
  "block.minecraft.stripped_dark_oak_log": "buștean de stejar negru decojit",
  "block.minecraft.stripped_crimson_stem": "tulpină stacojie decojită",
  "block.minecraft.stripped_warped_stem": "tulpină deformată decojită",
  "block.minecraft.stripped_oak_wood": "lemn de stejar decojit",
  "block.minecraft.stripped_spruce_wood": "lemn de molid decojit",
  "block.minecraft.stripped_birch_wood": "lemn de mesteacăn decojit",
  "block.minecraft.stripped_jungle_wood": "lemn de junglă decojit",
  "block.minecraft.stripped_acacia_wood": "lemn de salcâm decojit",
  "block.minecraft.stripped_dark_oak_wood": "lemn de stejar negru decojit",
  "block.minecraft.stripped_crimson_hyphae": "hife stacojii decojite",
  "block.minecraft.stripped_warped_hyphae": "hife deformate decojite",
  "block.minecraft.oak_wood": "lemn de stejar",
  "block.minecraft.spruce_wood": "lemn de molid",
  "block.minecraft.birch_wood": "lemn de mesteacăn",
  "block.minecraft.jungle_wood": "lemn de junglă",
  "block.minecraft.acacia_wood": "lemn de salcâm",
  "block.minecraft.dark_oak_wood": "lemn de stejar negru",
  "block.minecraft.crimson_hyphae": "hife stacojii",
  "block.minecraft.warped_hyphae": "hife deformate",
  "block.minecraft.oak_leaves": "frunze de stejar",
  "block.minecraft.spruce_leaves": "frunze de molid",
  "block.minecraft.birch_leaves": "frunze de mesteacăn",
  "block.minecraft.jungle_leaves": "frunze de junglă",
  "block.minecraft.acacia_leaves": "frunze de salcâm",
  "block.minecraft.dark_oak_leaves": "frunze de stejar negru",
  "block.minecraft.sponge": "burete",
  "block.minecraft.wet_sponge": "burete ud",
  "block.minecraft.glass": "sticlă",
  "block.minecraft.lapis_ore": "minereu de lapislazuli",
  "block.minecraft.lapis_block": "bloc de lapislazuli",
  "block.minecraft.dispenser": "distribuitor",
  "block.minecraft.sandstone": "gresie",
  "block.minecraft.chiseled_sandstone": "gresie sculptată",
  "block.minecraft.cut_sandstone": "gresie tăiată",
  "block.minecraft.note_block": "bloc muzical",
  "block.minecraft.powered_rail": "șine propulsoare",
  "block.minecraft.detector_rail": "șine detectoare",
  "block.minecraft.sticky_piston": "piston lipicios",
  "block.minecraft.cobweb": "pânză de păianjen",
  "block.minecraft.grass": "iarbă",
  "block.minecraft.fern": "ferigă",
  "block.minecraft.dead_bush": "tufă uscată",
  "block.minecraft.seagrass": "iarbă de mare",
  "block.minecraft.sea_pickle": "pirozom",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "lână albă",
  "block.minecraft.orange_wool": "lână portocalie",
  "block.minecraft.magenta_wool": "lână magenta",
  "block.minecraft.light_blue_wool": "lână bleu",
  "block.minecraft.yellow_wool": "lână galbenă",
  "block.minecraft.lime_wool": "lână verde-deschis",
  "block.minecraft.pink_wool": "lână roz",
  "block.minecraft.gray_wool": "lână gri",
  "block.minecraft.light_gray_wool": "lână gri-deschis",
  "block.minecraft.cyan_wool": "lână turcoaz",
  "block.minecraft.purple_wool": "lână violetă",
  "block.minecraft.blue_wool": "lână albastră",
  "block.minecraft.brown_wool": "lână maro",
  "block.minecraft.green_wool": "lână verde",
  "block.minecraft.red_wool": "lână roșie",
  "block.minecraft.black_wool": "lână neagră",
  "block.minecraft.dandelion": "păpădie",
  "block.minecraft.poppy": "mac",
  "block.minecraft.blue_orchid": "orhidee albastră",
  "block.minecraft.allium": "arpagic",
  "block.minecraft.azure_bluet": "lăptișor",
  "block.minecraft.red_tulip": "lalea roșie",
  "block.minecraft.orange_tulip": "lalea portocalie",
  "block.minecraft.white_tulip": "lalea albă",
  "block.minecraft.pink_tulip": "lalea roz",
  "block.minecraft.oxeye_daisy": "margaretă",
  "block.minecraft.cornflower": "albăstrea",
  "block.minecraft.lily_of_the_valley": "lăcrămioară",
  "block.minecraft.wither_rose": "trandafirul witherului",
  "block.minecraft.brown_mushroom": "ciupercă maro",
  "block.minecraft.red_mushroom": "ciupercă roșie",
  "block.minecraft.crimson_fungus": "ciupercă stacojie",
  "block.minecraft.warped_fungus": "ciupercă deformată",
  "block.minecraft.crimson_roots": "rădăcini stacojii",
  "block.minecraft.warped_roots": "rădăcini deformate",
  "block.minecraft.nether_sprouts": "lăstari din nether",
  "block.minecraft.weeping_vines": "liane plângătoare",
  "block.minecraft.twisting_vines": "liane răsucite",
  "block.minecraft.sugar_cane": "trestie de zahăr",
  "block.minecraft.kelp": "algă",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "bloc de aur",
  "block.minecraft.iron_block": "bloc de fier",
  "block.minecraft.oak_slab": "lespede de stejar",
  "block.minecraft.spruce_slab": "lespede de molid",
  "block.minecraft.birch_slab": "lespede de mesteacăn",
  "block.minecraft.jungle_slab": "lespede de junglă",
  "block.minecraft.acacia_slab": "lespede de salcâm",
  "block.minecraft.dark_oak_slab": "lespede de stejar negru",
  "block.minecraft.crimson_slab": "lespede stacojie",
  "block.minecraft.warped_slab": "lespede deformată",
  "block.minecraft.stone_slab": "lespede de piatră",
  "block.minecraft.smooth_stone_slab": "lespede de piatră netedă",
  "block.minecraft.sandstone_slab": "lespede de gresie",
  "block.minecraft.cut_sandstone_slab": "lespede de gresie tăiată",
  "block.minecraft.petrified_oak_slab": "lespede de stejar pietrificată",
  "block.minecraft.cobblestone_slab": "lespede de pietruială",
  "block.minecraft.brick_slab": "lespede de cărămizi",
  "block.minecraft.stone_brick_slab": "lespede de cărămizi de piatră",
  "block.minecraft.nether_brick_slab": "lespede de cărămizi de nether",
  "block.minecraft.quartz_slab": "lespede de cuarț",
  "block.minecraft.red_sandstone_slab": "lespede de gresie roșie",
  "block.minecraft.cut_red_sandstone_slab": "lespede de gresie roșie tăiată",
  "block.minecraft.purpur_slab": "lespede de purpur",
  "block.minecraft.prismarine_slab": "lespede de prismarin",
  "block.minecraft.prismarine_brick_slab": "lespede de cărămizi de prismarin",
  "block.minecraft.dark_prismarine_slab": "lespede de prismarin întunecat",
  "block.minecraft.smooth_quartz": "bloc de cuarț neted",
  "block.minecraft.smooth_red_sandstone": "gresie roșie netedă",
  "block.minecraft.smooth_sandstone": "gresie netedă",
  "block.minecraft.smooth_stone": "piatră netedă",
  "block.minecraft.bricks": "cărămizi",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bibliotecă",
  "block.minecraft.mossy_cobblestone": "pietruială cu mușchi",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "torță",
  "block.minecraft.end_rod": "bară din end",
  "block.minecraft.chorus_plant": "plantă corală",
  "block.minecraft.chorus_flower": "floare corală",
  "block.minecraft.purpur_block": "bloc de purpur",
  "block.minecraft.purpur_pillar": "coloană de purpur",
  "block.minecraft.purpur_stairs": "trepte de purpur",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "trepte de stejar",
  "block.minecraft.chest": "cufăr",
  "block.minecraft.diamond_ore": "minereu de diamant",
  "block.minecraft.diamond_block": "bloc de diamant",
  "block.minecraft.crafting_table": "masă de lucru",
  "block.minecraft.farmland": "teren agricol",
  "block.minecraft.furnace": "cuptor",
  "block.minecraft.ladder": "scară",
  "block.minecraft.rail": "șine",
  "block.minecraft.cobblestone_stairs": "trepte de pietruială",
  "block.minecraft.lever": "manetă",
  "block.minecraft.stone_pressure_plate": "placă de presiune de piatră",
  "block.minecraft.oak_pressure_plate": "placă de presiune de stejar",
  "block.minecraft.spruce_pressure_plate": "placă de presiune de molid",
  "block.minecraft.birch_pressure_plate": "placă de presiune de mesteacăn",
  "block.minecraft.jungle_pressure_plate": "placă de presiune de junglă",
  "block.minecraft.acacia_pressure_plate": "placă de presiune de salcâm",
  "block.minecraft.dark_oak_pressure_plate": "placă de presiune de stejar negru",
  "block.minecraft.crimson_pressure_plate": "placă de presiune stacojie",
  "block.minecraft.warped_pressure_plate": "placă de presiune deformată",
  "block.minecraft.polished_blackstone_pressure_plate": "placă de presiune de piatră neagră șlefuită",
  "block.minecraft.redstone_ore": "minereu de redstone",
  "block.minecraft.redstone_torch": "torță de redstone",
  "block.minecraft.snow": "zăpadă",
  "block.minecraft.ice": "gheață",
  "block.minecraft.snow_block": "bloc de zăpadă",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "lut",
  "block.minecraft.jukebox": "tonomat",
  "block.minecraft.oak_fence": "gard de stejar",
  "block.minecraft.spruce_fence": "gard de molid",
  "block.minecraft.birch_fence": "gard de mesteacăn",
  "block.minecraft.jungle_fence": "gard de junglă",
  "block.minecraft.acacia_fence": "gard de salcâm",
  "block.minecraft.dark_oak_fence": "gard de stejar negru",
  "block.minecraft.crimson_fence": "gard stacojiu",
  "block.minecraft.warped_fence": "gard deformat",
  "block.minecraft.pumpkin": "dovleac",
  "block.minecraft.carved_pumpkin": "dovleac sculptat",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "nisip de suflete",
  "block.minecraft.soul_soil": "sol de suflete",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "bazalt șlefuit",
  "block.minecraft.soul_torch": "torță de suflete",
  "block.minecraft.glowstone": "piatră strălucitoare",
  "block.minecraft.jack_o_lantern": "dovleac de halloween",
  "block.minecraft.oak_trapdoor": "trapă de stejar",
  "block.minecraft.spruce_trapdoor": "trapă de molid",
  "block.minecraft.birch_trapdoor": "trapă de mesteacăn",
  "block.minecraft.jungle_trapdoor": "trapă de junglă",
  "block.minecraft.acacia_trapdoor": "trapă de salcâm",
  "block.minecraft.dark_oak_trapdoor": "trapă de stejar negru",
  "block.minecraft.crimson_trapdoor": "trapă stacojie",
  "block.minecraft.warped_trapdoor": "trapă deformată",
  "block.minecraft.infested_stone": "piatră infestată",
  "block.minecraft.infested_cobblestone": "pietruială infestată",
  "block.minecraft.infested_stone_bricks": "cărămizi de piatră infestate",
  "block.minecraft.infested_mossy_stone_bricks": "cărămizi de piatră cu mușchi infestate",
  "block.minecraft.infested_cracked_stone_bricks": "cărămizi de piatră crăpate infestate",
  "block.minecraft.infested_chiseled_stone_bricks": "cărămizi de piatră sculptată infestate",
  "block.minecraft.stone_bricks": "cărămizi de piatră",
  "block.minecraft.mossy_stone_bricks": "cărămizi de piatră cu mușchi",
  "block.minecraft.cracked_stone_bricks": "cărămizi de piatră crăpate",
  "block.minecraft.chiseled_stone_bricks": "cărămizi de piatră sculptate",
  "block.minecraft.brown_mushroom_block": "bloc de ciupercă maro",
  "block.minecraft.red_mushroom_block": "bloc de ciupercă roșie",
  "block.minecraft.mushroom_stem": "picior de ciupercă",
  "block.minecraft.iron_bars": "gratii de fier",
  "block.minecraft.chain": "lanț",
  "block.minecraft.glass_pane": "geam",
  "block.minecraft.melon": "pepene",
  "block.minecraft.vine": "liane",
  "block.minecraft.oak_fence_gate": "portiță de stejar",
  "block.minecraft.spruce_fence_gate": "portiță de molid",
  "block.minecraft.birch_fence_gate": "portiță de mesteacăn",
  "block.minecraft.jungle_fence_gate": "portiță de junglă",
  "block.minecraft.acacia_fence_gate": "portiță de salcâm",
  "block.minecraft.dark_oak_fence_gate": "portiță de stejar negru",
  "block.minecraft.crimson_fence_gate": "portiță stacojie",
  "block.minecraft.warped_fence_gate": "portiță deformată",
  "block.minecraft.brick_stairs": "trepte de cărămizi",
  "block.minecraft.stone_brick_stairs": "trepte de cărămizi de piatră",
  "block.minecraft.mycelium": "miceliu",
  "block.minecraft.lily_pad": "nufăr",
  "block.minecraft.nether_bricks": "cărămizi de nether",
  "block.minecraft.cracked_nether_bricks": "cărămizi de nether crăpate",
  "block.minecraft.chiseled_nether_bricks": "cărămizi de nether sculptate",
  "block.minecraft.nether_brick_fence": "gard de cărămizi de nether",
  "block.minecraft.nether_brick_stairs": "trepte de cărămizi de nether",
  "block.minecraft.enchanting_table": "masă de farmece",
  "block.minecraft.end_portal_frame": "cadru de portal spre end",
  "block.minecraft.end_stone": "piatră din end",
  "block.minecraft.end_stone_bricks": "cărămizi de piatră din end",
  "block.minecraft.dragon_egg": "ou de dragon",
  "block.minecraft.redstone_lamp": "lampă de redstone",
  "block.minecraft.sandstone_stairs": "trepte de gresie",
  "block.minecraft.emerald_ore": "minereu de smarald",
  "block.minecraft.ender_chest": "cufăr de ender",
  "block.minecraft.tripwire_hook": "cârlig pentru fir",
  "block.minecraft.emerald_block": "bloc de smarald",
  "block.minecraft.spruce_stairs": "trepte de molid",
  "block.minecraft.birch_stairs": "trepte de mesteacăn",
  "block.minecraft.jungle_stairs": "trepte de junglă",
  "block.minecraft.crimson_stairs": "trepte stacojii",
  "block.minecraft.warped_stairs": "trepte deformate",
  "block.minecraft.command_block": "bloc de comenzi",
  "block.minecraft.beacon": "far",
  "block.minecraft.cobblestone_wall": "zid de pietruială",
  "block.minecraft.mossy_cobblestone_wall": "zid de pietruială cu mușchi",
  "block.minecraft.brick_wall": "zid de cărămizi",
  "block.minecraft.prismarine_wall": "zid de prismarin",
  "block.minecraft.red_sandstone_wall": "zid de gresie roșie",
  "block.minecraft.mossy_stone_brick_wall": "zid de cărămizi de piatră cu mușchi",
  "block.minecraft.granite_wall": "zid de granit",
  "block.minecraft.stone_brick_wall": "zid de cărămizi de piatră",
  "block.minecraft.nether_brick_wall": "zid de cărămizi de nether",
  "block.minecraft.andesite_wall": "zid de andezit",
  "block.minecraft.red_nether_brick_wall": "zid de cărămizi de nether roșii",
  "block.minecraft.sandstone_wall": "zid de gresie",
  "block.minecraft.end_stone_brick_wall": "zid de cărămizi de piatră din end",
  "block.minecraft.diorite_wall": "zid de diorit",
  "block.minecraft.blackstone_wall": "zid de piatră neagră",
  "block.minecraft.polished_blackstone_wall": "zid de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_brick_wall": "zid de cărămizi de piatră neagră șlefuită",
  "block.minecraft.stone_button": "buton de piatră",
  "block.minecraft.oak_button": "buton de stejar",
  "block.minecraft.spruce_button": "buton de molid",
  "block.minecraft.birch_button": "buton de mesteacăn",
  "block.minecraft.jungle_button": "buton de junglă",
  "block.minecraft.acacia_button": "buton de salcâm",
  "block.minecraft.dark_oak_button": "buton de stejar negru",
  "block.minecraft.crimson_button": "buton stacojiu",
  "block.minecraft.warped_button": "buton deformat",
  "block.minecraft.polished_blackstone_button": "buton de piatră neagră șlefuită",
  "block.minecraft.anvil": "nicovală",
  "block.minecraft.chipped_anvil": "nicovală lovită",
  "block.minecraft.damaged_anvil": "nicovală stricată",
  "block.minecraft.trapped_chest": "cufăr-capcană",
  "block.minecraft.light_weighted_pressure_plate": "placă de presiune ponderată ușoară",
  "block.minecraft.heavy_weighted_pressure_plate": "placă de presiune ponderată grea",
  "block.minecraft.daylight_detector": "detector solar",
  "block.minecraft.redstone_block": "bloc de redstone",
  "block.minecraft.nether_quartz_ore": "minereu de cuarț de nether",
  "block.minecraft.hopper": "pâlnie",
  "block.minecraft.chiseled_quartz_block": "bloc de cuarț sculptat",
  "block.minecraft.quartz_block": "bloc de cuarț",
  "block.minecraft.quartz_bricks": "cărămizi de cuarț",
  "block.minecraft.quartz_pillar": "coloană de cuarț",
  "block.minecraft.quartz_stairs": "trepte de cuarț",
  "block.minecraft.activator_rail": "șine activatoare",
  "block.minecraft.dropper": "aruncător",
  "block.minecraft.white_terracotta": "teracotă albă",
  "block.minecraft.orange_terracotta": "teracotă portocalie",
  "block.minecraft.magenta_terracotta": "teracotă magenta",
  "block.minecraft.light_blue_terracotta": "teracotă bleu",
  "block.minecraft.yellow_terracotta": "teracotă galbenă",
  "block.minecraft.lime_terracotta": "teracotă verde-deschis",
  "block.minecraft.pink_terracotta": "teracotă roz",
  "block.minecraft.gray_terracotta": "teracotă gri",
  "block.minecraft.light_gray_terracotta": "teracotă gri-deschis",
  "block.minecraft.cyan_terracotta": "teracotă turcoaz",
  "block.minecraft.purple_terracotta": "teracotă violetă",
  "block.minecraft.blue_terracotta": "teracotă albastră",
  "block.minecraft.brown_terracotta": "teracotă maro",
  "block.minecraft.green_terracotta": "teracotă verde",
  "block.minecraft.red_terracotta": "teracotă roșie",
  "block.minecraft.black_terracotta": "teracotă neagră",
  "block.minecraft.barrier": "barieră",
  "block.minecraft.iron_trapdoor": "trapă de fier",
  "block.minecraft.hay_block": "balot de paie",
  "block.minecraft.white_carpet": "covor alb",
  "block.minecraft.orange_carpet": "covor portocaliu",
  "block.minecraft.magenta_carpet": "covor magenta",
  "block.minecraft.light_blue_carpet": "covor bleu",
  "block.minecraft.yellow_carpet": "covor galben",
  "block.minecraft.lime_carpet": "covor verde-deschis",
  "block.minecraft.pink_carpet": "covor roz",
  "block.minecraft.gray_carpet": "covor gri",
  "block.minecraft.light_gray_carpet": "covor gri-deschis",
  "block.minecraft.cyan_carpet": "covor turcoaz",
  "block.minecraft.purple_carpet": "covor violet",
  "block.minecraft.blue_carpet": "covor albastru",
  "block.minecraft.brown_carpet": "covor maro",
  "block.minecraft.green_carpet": "covor verde",
  "block.minecraft.red_carpet": "covor roșu",
  "block.minecraft.black_carpet": "covor negru",
  "block.minecraft.terracotta": "teracotă",
  "block.minecraft.coal_block": "bloc de cărbune",
  "block.minecraft.packed_ice": "gheață compactă",
  "block.minecraft.acacia_stairs": "trepte de salcâm",
  "block.minecraft.dark_oak_stairs": "trepte de stejar negru",
  "block.minecraft.slime_block": "bloc de mâzgă",
  "block.minecraft.grass_path": "cărare de iarbă",
  "block.minecraft.sunflower": "floarea-soarelui",
  "block.minecraft.lilac": "liliac",
  "block.minecraft.rose_bush": "tufă de trandafiri",
  "block.minecraft.peony": "bujor",
  "block.minecraft.tall_grass": "iarbă înaltă",
  "block.minecraft.large_fern": "ferigă mare",
  "block.minecraft.white_stained_glass": "sticlă albă",
  "block.minecraft.orange_stained_glass": "sticlă portocalie",
  "block.minecraft.magenta_stained_glass": "sticlă magenta",
  "block.minecraft.light_blue_stained_glass": "sticlă bleu",
  "block.minecraft.yellow_stained_glass": "sticlă galbenă",
  "block.minecraft.lime_stained_glass": "sticlă verde-deschis",
  "block.minecraft.pink_stained_glass": "sticlă roz",
  "block.minecraft.gray_stained_glass": "sticlă gri",
  "block.minecraft.light_gray_stained_glass": "sticlă gri-deschis",
  "block.minecraft.cyan_stained_glass": "sticlă turcoaz",
  "block.minecraft.purple_stained_glass": "sticlă violetă",
  "block.minecraft.blue_stained_glass": "sticlă albastră",
  "block.minecraft.brown_stained_glass": "sticlă maro",
  "block.minecraft.green_stained_glass": "sticlă verde",
  "block.minecraft.red_stained_glass": "sticlă roșie",
  "block.minecraft.black_stained_glass": "sticlă neagră",
  "block.minecraft.white_stained_glass_pane": "geam alb",
  "block.minecraft.orange_stained_glass_pane": "geam portocaliu",
  "block.minecraft.magenta_stained_glass_pane": "geam magenta",
  "block.minecraft.light_blue_stained_glass_pane": "geam bleu",
  "block.minecraft.yellow_stained_glass_pane": "geam galben",
  "block.minecraft.lime_stained_glass_pane": "geam verde-deschis",
  "block.minecraft.pink_stained_glass_pane": "geam roz",
  "block.minecraft.gray_stained_glass_pane": "geam gri",
  "block.minecraft.light_gray_stained_glass_pane": "geam gri-deschis",
  "block.minecraft.cyan_stained_glass_pane": "geam turcoaz",
  "block.minecraft.purple_stained_glass_pane": "geam violet",
  "block.minecraft.blue_stained_glass_pane": "geam albastru",
  "block.minecraft.brown_stained_glass_pane": "geam maro",
  "block.minecraft.green_stained_glass_pane": "geam verde",
  "block.minecraft.red_stained_glass_pane": "geam roșu",
  "block.minecraft.black_stained_glass_pane": "geam negru",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "cărămizi de prismarin",
  "block.minecraft.dark_prismarine": "prismarin întunecat",
  "block.minecraft.prismarine_stairs": "trepte de prismarin",
  "block.minecraft.prismarine_brick_stairs": "trepte de cărămizi de prismarin",
  "block.minecraft.dark_prismarine_stairs": "trepte de prismarin întunecat",
  "block.minecraft.sea_lantern": "felinar marin",
  "block.minecraft.red_sandstone": "gresie roșie",
  "block.minecraft.chiseled_red_sandstone": "gresie roșie sculptată",
  "block.minecraft.cut_red_sandstone": "gresie roșie tăiată",
  "block.minecraft.red_sandstone_stairs": "trepte de gresie roșie",
  "block.minecraft.repeating_command_block": "bloc de comenzi cu repetiție",
  "block.minecraft.chain_command_block": "bloc de comenzi în lanț",
  "block.minecraft.magma_block": "bloc de magmă",
  "block.minecraft.nether_wart_block": "bloc de negi din nether",
  "block.minecraft.warped_wart_block": "bloc de neg deformat",
  "block.minecraft.red_nether_bricks": "cărămizi de nether roșii",
  "block.minecraft.bone_block": "bloc de oase",
  "block.minecraft.structure_void": "vid de structură",
  "block.minecraft.observer": "observator",
  "block.minecraft.shulker_box": "cutie de shulker",
  "block.minecraft.white_shulker_box": "cutie de shulker albă",
  "block.minecraft.orange_shulker_box": "cutie de shulker portocalie",
  "block.minecraft.magenta_shulker_box": "cutie de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "cutie de shulker bleu",
  "block.minecraft.yellow_shulker_box": "cutie de shulker galbenă",
  "block.minecraft.lime_shulker_box": "cutie de shulker verde-deschis",
  "block.minecraft.pink_shulker_box": "cutie de shulker roz",
  "block.minecraft.gray_shulker_box": "cutie de shulker gri",
  "block.minecraft.light_gray_shulker_box": "cutie de shulker gri-deschis",
  "block.minecraft.cyan_shulker_box": "cutie de shulker turcoaz",
  "block.minecraft.purple_shulker_box": "cutie de shulker violetă",
  "block.minecraft.blue_shulker_box": "cutie de shulker albastră",
  "block.minecraft.brown_shulker_box": "cutie de shulker maro",
  "block.minecraft.green_shulker_box": "cutie de shulker verde",
  "block.minecraft.red_shulker_box": "cutie de shulker roșie",
  "block.minecraft.black_shulker_box": "cutie de shulker neagră",
  "block.minecraft.white_glazed_terracotta": "teracotă smălțuită albă",
  "block.minecraft.orange_glazed_terracotta": "teracotă smălțuită portocalie",
  "block.minecraft.magenta_glazed_terracotta": "teracotă smălțuită magenta",
  "block.minecraft.light_blue_glazed_terracotta": "teracotă smălțuită bleu",
  "block.minecraft.yellow_glazed_terracotta": "teracotă smălțuită galbenă",
  "block.minecraft.lime_glazed_terracotta": "teracotă smălțuită verde-deschis",
  "block.minecraft.pink_glazed_terracotta": "teracotă smălțuită roz",
  "block.minecraft.gray_glazed_terracotta": "teracotă smălțuită gri",
  "block.minecraft.light_gray_glazed_terracotta": "teracotă smălțuită gri-deschis",
  "block.minecraft.cyan_glazed_terracotta": "teracotă smălțuită turcoaz",
  "block.minecraft.purple_glazed_terracotta": "teracotă smălțuită violetă",
  "block.minecraft.blue_glazed_terracotta": "teracotă smălțuită albastră",
  "block.minecraft.brown_glazed_terracotta": "teracotă smălțuită maro",
  "block.minecraft.green_glazed_terracotta": "teracotă smălțuită verde",
  "block.minecraft.red_glazed_terracotta": "teracotă smălțuită roșie",
  "block.minecraft.black_glazed_terracotta": "teracotă smălțuită neagră",
  "block.minecraft.white_concrete": "beton alb",
  "block.minecraft.orange_concrete": "beton portocaliu",
  "block.minecraft.magenta_concrete": "beton magenta",
  "block.minecraft.light_blue_concrete": "beton bleu",
  "block.minecraft.yellow_concrete": "beton galben",
  "block.minecraft.lime_concrete": "beton verde-deschis",
  "block.minecraft.pink_concrete": "beton roz",
  "block.minecraft.gray_concrete": "beton gri",
  "block.minecraft.light_gray_concrete": "beton gri-deschis",
  "block.minecraft.cyan_concrete": "beton turcoaz",
  "block.minecraft.purple_concrete": "beton violet",
  "block.minecraft.blue_concrete": "beton albastru",
  "block.minecraft.brown_concrete": "beton maro",
  "block.minecraft.green_concrete": "beton verde",
  "block.minecraft.red_concrete": "beton roșu",
  "block.minecraft.black_concrete": "beton negru",
  "block.minecraft.white_concrete_powder": "beton uscat alb",
  "block.minecraft.orange_concrete_powder": "beton uscat portocaliu",
  "block.minecraft.magenta_concrete_powder": "beton uscat magenta",
  "block.minecraft.light_blue_concrete_powder": "beton uscat bleu",
  "block.minecraft.yellow_concrete_powder": "beton uscat galben",
  "block.minecraft.lime_concrete_powder": "beton uscat verde-deschis",
  "block.minecraft.pink_concrete_powder": "beton uscat roz",
  "block.minecraft.gray_concrete_powder": "beton uscat gri",
  "block.minecraft.light_gray_concrete_powder": "beton uscat gri-deschis",
  "block.minecraft.cyan_concrete_powder": "beton uscat turcoaz",
  "block.minecraft.purple_concrete_powder": "beton uscat violet",
  "block.minecraft.blue_concrete_powder": "beton uscat albastru",
  "block.minecraft.brown_concrete_powder": "beton uscat maro",
  "block.minecraft.green_concrete_powder": "beton uscat verde",
  "block.minecraft.red_concrete_powder": "beton uscat roșu",
  "block.minecraft.black_concrete_powder": "beton uscat negru",
  "block.minecraft.turtle_egg": "ou de țestoasă",
  "block.minecraft.dead_tube_coral_block": "bloc de coral tubular mort",
  "block.minecraft.dead_brain_coral_block": "bloc de coral creier mort",
  "block.minecraft.dead_bubble_coral_block": "bloc de coral balon mort",
  "block.minecraft.dead_fire_coral_block": "bloc de coral de foc mort",
  "block.minecraft.dead_horn_coral_block": "bloc de coral rugos mort",
  "block.minecraft.tube_coral_block": "bloc de coral tubular",
  "block.minecraft.brain_coral_block": "bloc de coral creier",
  "block.minecraft.bubble_coral_block": "bloc de coral balon",
  "block.minecraft.fire_coral_block": "bloc de coral de foc",
  "block.minecraft.horn_coral_block": "bloc de coral rugos",
  "block.minecraft.tube_coral": "coral tubular",
  "block.minecraft.brain_coral": "coral creier",
  "block.minecraft.bubble_coral": "coral balon",
  "block.minecraft.fire_coral": "coral de foc",
  "block.minecraft.horn_coral": "coral rugos",
  "block.minecraft.dead_brain_coral": "coral creier mort",
  "block.minecraft.dead_bubble_coral": "coral balon mort",
  "block.minecraft.dead_fire_coral": "coral de foc mort",
  "block.minecraft.dead_horn_coral": "coral rugos mort",
  "block.minecraft.dead_tube_coral": "coral tubular mort",
  "block.minecraft.tube_coral_fan": "gorgonie tubulară",
  "block.minecraft.brain_coral_fan": "gorgonie creier",
  "block.minecraft.bubble_coral_fan": "gorgonie balon",
  "block.minecraft.fire_coral_fan": "gorgonie de foc",
  "block.minecraft.horn_coral_fan": "gorgonie rugoasă",
  "block.minecraft.dead_tube_coral_fan": "gorgonie tubulară moartă",
  "block.minecraft.dead_brain_coral_fan": "gorgonie creier moartă",
  "block.minecraft.dead_bubble_coral_fan": "gorgonie balon moartă",
  "block.minecraft.dead_fire_coral_fan": "gorgonie de foc moartă",
  "block.minecraft.dead_horn_coral_fan": "gorgonie rugoasă moartă",
  "block.minecraft.blue_ice": "gheață albastră",
  "block.minecraft.conduit": "conduct",
  "block.minecraft.polished_granite_stairs": "trepte de granit șlefuit",
  "block.minecraft.smooth_red_sandstone_stairs": "trepte de gresie roșie netedă",
  "block.minecraft.mossy_stone_brick_stairs": "trepte de cărămizi de piatră cu mușchi",
  "block.minecraft.polished_diorite_stairs": "trepte de diorit șlefuit",
  "block.minecraft.mossy_cobblestone_stairs": "trepte de pietruială cu mușchi",
  "block.minecraft.end_stone_brick_stairs": "trepte de cărămizi de piatră din end",
  "block.minecraft.stone_stairs": "trepte de piatră",
  "block.minecraft.smooth_sandstone_stairs": "trepte de gresie netedă",
  "block.minecraft.smooth_quartz_stairs": "trepte de cuarț neted",
  "block.minecraft.granite_stairs": "trepte de granit",
  "block.minecraft.andesite_stairs": "trepte de andezit",
  "block.minecraft.red_nether_brick_stairs": "trepte de cărămizi de nether roșii",
  "block.minecraft.polished_andesite_stairs": "trepte de andezit șlefuit",
  "block.minecraft.diorite_stairs": "trepte de diorit",
  "block.minecraft.polished_granite_slab": "lespede de granit șlefuit",
  "block.minecraft.smooth_red_sandstone_slab": "lespede de gresie roșie netedă",
  "block.minecraft.mossy_stone_brick_slab": "lespede de cărămizi de piatră cu mușchi",
  "block.minecraft.polished_diorite_slab": "lespede de diorit șlefuit",
  "block.minecraft.mossy_cobblestone_slab": "lespede de pietruială cu mușchi",
  "block.minecraft.end_stone_brick_slab": "lespede de cărămizi de piatră din end",
  "block.minecraft.smooth_sandstone_slab": "lespede de gresie netedă",
  "block.minecraft.smooth_quartz_slab": "lespede de cuarț neted",
  "block.minecraft.granite_slab": "lespede de granit",
  "block.minecraft.andesite_slab": "lespede de andezit",
  "block.minecraft.red_nether_brick_slab": "lespede de cărămizi de nether roșii",
  "block.minecraft.polished_andesite_slab": "lespede de andezit șlefuit",
  "block.minecraft.diorite_slab": "lespede de diorit",
  "block.minecraft.scaffolding": "schelă",
  "block.minecraft.iron_door": "ușă de fier",
  "block.minecraft.oak_door": "ușă de stejar",
  "block.minecraft.spruce_door": "ușă de molid",
  "block.minecraft.birch_door": "ușă de mesteacăn",
  "block.minecraft.jungle_door": "ușă de junglă",
  "block.minecraft.acacia_door": "ușă de salcâm",
  "block.minecraft.dark_oak_door": "ușă de stejar negru",
  "block.minecraft.crimson_door": "ușă stacojie",
  "block.minecraft.warped_door": "ușă deformată",
  "block.minecraft.repeater": "repetor de redstone",
  "block.minecraft.comparator": "comparator de redstone",
  "block.minecraft.structure_block": "bloc de structură",
  "block.minecraft.jigsaw": "bloc de puzzle",
  "item.minecraft.turtle_helmet": "carapace de țestoasă□□cand este pe cap:□+2 armură",
  "item.minecraft.scute": "solz",
  "item.minecraft.iron_shovel": "lopată de fier□□în mâna principală:□+3.5 puncte de atac□-3 viteză de atac",
  "item.minecraft.iron_pickaxe": "târnăcop de fier□□în mâna principală:□+3 puncte de atac□-2.8 viteză de atac",
  "item.minecraft.iron_axe": "topor de fier□□în mâna principală:□+8 puncte de atac□-3.1 viteză de atac",
  "item.minecraft.flint_and_steel": "cremene și amnar",
  "item.minecraft.apple": "măr",
  "item.minecraft.bow": "arc",
  "item.minecraft.arrow": "săgeată",
  "item.minecraft.coal": "cărbune",
  "item.minecraft.charcoal": "cărbune de lemn",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingou de fier",
  "item.minecraft.gold_ingot": "lingou de aur",
  "item.minecraft.netherite_ingot": "lingou de netherit",
  "item.minecraft.netherite_scrap": "fragment de netherit",
  "item.minecraft.iron_sword": "sabie de fier□□în mâna principală:□+5 puncte de atac□-2.4 viteză de atac",
  "item.minecraft.wooden_sword": "sabie de lemn□□în mâna principală:□+3 puncte de atac□-2.4 viteză de atac",
  "item.minecraft.wooden_shovel": "lopată de lemn□□în mâna principală:□+1.5 puncte de atac□-3 viteză de atac",
  "item.minecraft.wooden_pickaxe": "târnăcop de lemn□□în mâna principală:□+1 puncte de atac□-2.8 viteză de atac",
  "item.minecraft.wooden_axe": "topor de lemn□□în mâna principală:□+6 puncte de atac□-3.2 viteză de atac",
  "item.minecraft.stone_sword": "sabie de piatră□□în mâna principală:□+4 puncte de atac□-2.4 viteză de atac",
  "item.minecraft.stone_shovel": "lopată de piatră□□în mâna principală:□+2.5 puncte de atac□-3 viteză de atac",
  "item.minecraft.stone_pickaxe": "târnăcop de piatră□□în mâna principală:□+2 puncte de atac□-2.8 viteză de atac",
  "item.minecraft.stone_axe": "topor de piatră□□în mâna principală:□+8 puncte de atac□-3.2 viteză de atac",
  "item.minecraft.diamond_sword": "sabie de diamant□□în mâna principală:□+6 puncte de atac□-2.4 viteză de atac",
  "item.minecraft.diamond_shovel": "lopată de diamant□□în mâna principală:□+4.5 puncte de atac□-3 viteză de atac",
  "item.minecraft.diamond_pickaxe": "târnăcop de diamant□□în mâna principală:□+4 puncte de atac□-2.8 viteză de atac",
  "item.minecraft.diamond_axe": "topor de diamant□□în mâna principală:□+8 puncte de atac□-3 viteză de atac",
  "item.minecraft.stick": "băț",
  "item.minecraft.bowl": "bol",
  "item.minecraft.mushroom_stew": "supă de ciuperci",
  "item.minecraft.golden_sword": "sabie de aur□□în mâna principală:□+3 puncte de atac□-2.4 viteză de atac",
  "item.minecraft.golden_shovel": "lopată de aur□□în mâna principală:□+1.5 puncte de atac□-3 viteză de atac",
  "item.minecraft.golden_pickaxe": "târnăcop de aur□□în mâna principală:□+1 puncte de atac□-2.8 viteză de atac",
  "item.minecraft.golden_axe": "topor de aur□□în mâna principală:□+6 puncte de atac□-3 viteză de atac",
  "item.minecraft.netherite_sword": "sabie de netherit□□în mâna principală:□+7 puncte de atac□-2.4 viteză de atac",
  "item.minecraft.netherite_shovel": "lopată de netherit□□în mâna principală:□+5.5 puncte de atac□-3 viteză de atac",
  "item.minecraft.netherite_pickaxe": "târnăcop de netherit□□în mâna principală:□+5 puncte de atac□-2.8 viteză de atac",
  "item.minecraft.netherite_axe": "topor de netherit□□în mâna principală:□+9 puncte de atac□-3 viteză de atac",
  "item.minecraft.string": "ață",
  "item.minecraft.feather": "pană",
  "item.minecraft.gunpowder": "praf de pușcă",
  "item.minecraft.wooden_hoe": "sapă de lemn□□în mâna principală:□-3 viteză de atac",
  "item.minecraft.stone_hoe": "sapă de piatră□□în mâna principală:□-2 viteză de atac",
  "item.minecraft.iron_hoe": "sapă de fier□□în mâna principală:□-1 viteză de atac",
  "item.minecraft.diamond_hoe": "sapă de diamant□□în mâna principală:",
  "item.minecraft.golden_hoe": "sapă de aur□□în mâna principală:□-3 viteză de atac",
  "item.minecraft.netherite_hoe": "sapă de netherit□□în mâna principală:",
  "item.minecraft.wheat_seeds": "semințe de grâu",
  "item.minecraft.wheat": "grâu",
  "item.minecraft.bread": "pâine",
  "item.minecraft.leather_helmet": "cască de piele□□cand este pe cap:□+1 armură",
  "item.minecraft.leather_chestplate": "tunică de piele□□cand este pe corp:□+3 armură",
  "item.minecraft.leather_leggings": "pantaloni de piele□□cand este pe picioare:□+2 armură",
  "item.minecraft.leather_boots": "cizme de piele□□cand este in picioare:□+1 armură",
  "item.minecraft.chainmail_helmet": "cască de zale□□cand este pe cap:□+2 armură",
  "item.minecraft.chainmail_chestplate": "platoșă de zale□□cand este pe corp:□+5 armură",
  "item.minecraft.chainmail_leggings": "jambiere de zale□□cand este pe picioare:□+4 armură",
  "item.minecraft.chainmail_boots": "cizme de zale□□cand este in picioare:□+1 armură",
  "item.minecraft.iron_helmet": "cască de fier□□cand este pe cap:□+2 armură",
  "item.minecraft.iron_chestplate": "platoșă de fier□□cand este pe corp:□+6 armură",
  "item.minecraft.iron_leggings": "jambiere de fier□□cand este pe picioare:□+5 armură",
  "item.minecraft.iron_boots": "cizme de fier□□cand este in picioare:□+2 armură",
  "item.minecraft.diamond_helmet": "cască de diamant□□cand este pe cap:□+3 armură□+2 duritate a armurii",
  "item.minecraft.diamond_chestplate": "platoșă de diamant□□cand este pe corp:□+8 armură□+2 duritate a armurii",
  "item.minecraft.diamond_leggings": "jambiere de diamant□□cand este pe picioare:□+6 armură□+2 duritate a armurii",
  "item.minecraft.diamond_boots": "cizme de diamant□□cand este in picioare:□+3 armură□+2 duritate a armurii",
  "item.minecraft.golden_helmet": "cască de aur□□cand este pe cap:□+2 armură",
  "item.minecraft.golden_chestplate": "platoșă de aur□□cand este pe corp:□+5 armură",
  "item.minecraft.golden_leggings": "jambiere de aur□□cand este pe picioare:□+3 armură",
  "item.minecraft.golden_boots": "cizme de aur□□cand este in picioare:□+1 armură",
  "item.minecraft.netherite_helmet": "cască de netherit□□cand este pe cap:□+3 armură□+3 duritate a armurii□+1 rezistență la recul",
  "item.minecraft.netherite_chestplate": "platoșă de netherit□□cand este pe corp:□+8 armură□+3 duritate a armurii□+1 rezistență la recul",
  "item.minecraft.netherite_leggings": "jambiere de netherit□□cand este pe picioare:□+6 armură□+3 duritate a armurii□+1 rezistență la recul",
  "item.minecraft.netherite_boots": "cizme de netherit□□cand este in picioare:□+3 armură□+3 duritate a armurii□+1 rezistență la recul",
  "item.minecraft.flint": "cremene",
  "item.minecraft.porkchop": "carne de porc crudă",
  "item.minecraft.cooked_porkchop": "carne de porc friptă",
  "item.minecraft.painting": "pictură",
  "item.minecraft.golden_apple": "măr de aur",
  "item.minecraft.enchanted_golden_apple": "măr de aur fermecat",
  "block.minecraft.oak_sign": "semn de stejar",
  "block.minecraft.spruce_sign": "semn de molid",
  "block.minecraft.birch_sign": "semn de mesteacăn",
  "block.minecraft.jungle_sign": "semn de junglă",
  "block.minecraft.acacia_sign": "semn de salcâm",
  "block.minecraft.dark_oak_sign": "semn de stejar negru",
  "block.minecraft.crimson_sign": "semn stacojiu",
  "block.minecraft.warped_sign": "semn deformat",
  "item.minecraft.bucket": "găleată",
  "item.minecraft.water_bucket": "găleată cu apă",
  "item.minecraft.lava_bucket": "găleată cu lavă",
  "item.minecraft.minecart": "vagonet",
  "item.minecraft.saddle": "șa",
  "item.minecraft.redstone": "praf de redstone",
  "item.minecraft.snowball": "bulgăre de zăpadă",
  "item.minecraft.oak_boat": "barcă de stejar",
  "item.minecraft.leather": "piele",
  "item.minecraft.milk_bucket": "găleată cu lapte",
  "item.minecraft.pufferfish_bucket": "găleată cu pește-balon",
  "item.minecraft.salmon_bucket": "găleată cu somon",
  "item.minecraft.cod_bucket": "găleată cu cod",
  "item.minecraft.tropical_fish_bucket": "găleată cu pește tropical",
  "item.minecraft.brick": "cărămidă",
  "item.minecraft.clay_ball": "bulgăre de lut",
  "block.minecraft.dried_kelp_block": "bloc de alge uscate",
  "item.minecraft.paper": "hârtie",
  "item.minecraft.book": "carte",
  "item.minecraft.slime_ball": "bulgăre de mâzgă",
  "item.minecraft.chest_minecart": "cufăr în vagonet",
  "item.minecraft.furnace_minecart": "cuptor în vagonet",
  "item.minecraft.egg": "ou",
  "item.minecraft.compass": "busolă",
  "item.minecraft.fishing_rod": "undiță",
  "item.minecraft.clock": "ceas",
  "item.minecraft.glowstone_dust": "praf strălucitor",
  "item.minecraft.cod": "cod crud",
  "item.minecraft.salmon": "somon crud",
  "item.minecraft.tropical_fish": "pește tropical",
  "item.minecraft.pufferfish": "pește-balon",
  "item.minecraft.cooked_cod": "cod fript",
  "item.minecraft.cooked_salmon": "somon fript",
  "item.minecraft.ink_sac": "pungă de cerneală",
  "item.minecraft.red_dye": "colorant roșu",
  "item.minecraft.green_dye": "colorant verde",
  "item.minecraft.cocoa_beans": "boabe de cacao",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "colorant violet",
  "item.minecraft.cyan_dye": "colorant turcoaz",
  "item.minecraft.light_gray_dye": "colorant gri-deschis",
  "item.minecraft.gray_dye": "colorant gri",
  "item.minecraft.pink_dye": "colorant roz",
  "item.minecraft.lime_dye": "colorant verde-deschis",
  "item.minecraft.yellow_dye": "colorant galben",
  "item.minecraft.light_blue_dye": "colorant bleu",
  "item.minecraft.magenta_dye": "colorant magenta",
  "item.minecraft.orange_dye": "colorant portocaliu",
  "item.minecraft.bone_meal": "făină de oase",
  "item.minecraft.blue_dye": "colorant albastru",
  "item.minecraft.brown_dye": "colorant maro",
  "item.minecraft.black_dye": "colorant negru",
  "item.minecraft.white_dye": "colorant alb",
  "item.minecraft.bone": "os",
  "item.minecraft.sugar": "zahăr",
  "block.minecraft.cake": "tort",
  "block.minecraft.white_bed": "pat alb",
  "block.minecraft.orange_bed": "pat portocaliu",
  "block.minecraft.magenta_bed": "pat magenta",
  "block.minecraft.light_blue_bed": "pat bleu",
  "block.minecraft.yellow_bed": "pat galben",
  "block.minecraft.lime_bed": "pat verde-deschis",
  "block.minecraft.pink_bed": "pat roz",
  "block.minecraft.gray_bed": "pat gri",
  "block.minecraft.light_gray_bed": "pat gri-deschis",
  "block.minecraft.cyan_bed": "pat turcoaz",
  "block.minecraft.purple_bed": "pat violet",
  "block.minecraft.blue_bed": "pat albastru",
  "block.minecraft.brown_bed": "pat maro",
  "block.minecraft.green_bed": "pat verde",
  "block.minecraft.red_bed": "pat roșu",
  "block.minecraft.black_bed": "pat negru",
  "item.minecraft.cookie": "fursec",
  "item.minecraft.filled_map": "hartă□#0",
  "item.minecraft.shears": "foarfece",
  "item.minecraft.melon_slice": "felie de pepene",
  "item.minecraft.dried_kelp": "algă uscată",
  "item.minecraft.pumpkin_seeds": "semințe de dovleac",
  "item.minecraft.melon_seeds": "semințe de pepene",
  "item.minecraft.beef": "carne de vită crudă",
  "item.minecraft.cooked_beef": "carne de vită friptă",
  "item.minecraft.chicken": "găină crudă",
  "item.minecraft.cooked_chicken": "găină friptă",
  "item.minecraft.rotten_flesh": "carne putrezită",
  "item.minecraft.ender_pearl": "perlă de ender",
  "item.minecraft.blaze_rod": "tijă dogoritoare",
  "item.minecraft.ghast_tear": "lacrimă de ghast",
  "item.minecraft.gold_nugget": "pepită de aur",
  "item.minecraft.nether_wart": "neg din nether",
  "item.minecraft.potion": "poțiune nefabricabilă□niciun efect",
  "item.minecraft.glass_bottle": "sticluță goală",
  "item.minecraft.spider_eye": "ochi de păianjen",
  "item.minecraft.fermented_spider_eye": "ochi de păianjen fermentat",
  "item.minecraft.blaze_powder": "pulbere dogoritoare",
  "item.minecraft.magma_cream": "cremă de magmă",
  "block.minecraft.brewing_stand": "alambic",
  "block.minecraft.cauldron": "cazan",
  "item.minecraft.ender_eye": "ochi de ender",
  "item.minecraft.glistering_melon_slice": "felie de pepene strălucitoare",
  "item.minecraft.bat_spawn_egg": "ou generator de liliac",
  "item.minecraft.bee_spawn_egg": "ou generator de albină",
  "item.minecraft.blaze_spawn_egg": "ou generator de dogoreală",
  "item.minecraft.cat_spawn_egg": "ou generator de pisică",
  "item.minecraft.cave_spider_spawn_egg": "ou generator de păianjen de peșteră",
  "item.minecraft.chicken_spawn_egg": "ou generator de găină",
  "item.minecraft.cod_spawn_egg": "ou generator de cod",
  "item.minecraft.cow_spawn_egg": "ou generator de vacă",
  "item.minecraft.creeper_spawn_egg": "ou generator de creeper",
  "item.minecraft.dolphin_spawn_egg": "ou generator de delfin",
  "item.minecraft.donkey_spawn_egg": "ou generator de măgar",
  "item.minecraft.drowned_spawn_egg": "ou generator de înecat",
  "item.minecraft.elder_guardian_spawn_egg": "ou generator de mare străjer",
  "item.minecraft.enderman_spawn_egg": "ou generator de enderman",
  "item.minecraft.endermite_spawn_egg": "ou generator de endermite",
  "item.minecraft.evoker_spawn_egg": "ou generator de evocator",
  "item.minecraft.fox_spawn_egg": "ou generator de vulpe",
  "item.minecraft.ghast_spawn_egg": "ou generator de ghast",
  "item.minecraft.guardian_spawn_egg": "ou generator de străjer",
  "item.minecraft.hoglin_spawn_egg": "ou generator de hoglin",
  "item.minecraft.horse_spawn_egg": "ou generator de cal",
  "item.minecraft.husk_spawn_egg": "ou generator de momâie",
  "item.minecraft.llama_spawn_egg": "ou generator de lamă",
  "item.minecraft.magma_cube_spawn_egg": "ou generator de cub de magmă",
  "item.minecraft.mooshroom_spawn_egg": "ou generator de ciuvacă",
  "item.minecraft.mule_spawn_egg": "ou generator de catâr",
  "item.minecraft.ocelot_spawn_egg": "ou generator de ocelot",
  "item.minecraft.panda_spawn_egg": "ou generator de panda",
  "item.minecraft.parrot_spawn_egg": "ou generator de papagal",
  "item.minecraft.phantom_spawn_egg": "ou generator de fantasmă",
  "item.minecraft.pig_spawn_egg": "ou generator de porc",
  "item.minecraft.piglin_spawn_egg": "ou generator de piglin",
  "item.minecraft.pillager_spawn_egg": "ou generator de jefuitor",
  "item.minecraft.polar_bear_spawn_egg": "ou generator de urs polar",
  "item.minecraft.pufferfish_spawn_egg": "ou generator de pește-balon",
  "item.minecraft.rabbit_spawn_egg": "ou generator de iepure",
  "item.minecraft.ravager_spawn_egg": "ou generator de distrugător",
  "item.minecraft.salmon_spawn_egg": "ou generator de somon",
  "item.minecraft.sheep_spawn_egg": "ou generator de oaie",
  "item.minecraft.shulker_spawn_egg": "ou generator de shulker",
  "item.minecraft.silverfish_spawn_egg": "ou generator de peștișor argintiu",
  "item.minecraft.skeleton_spawn_egg": "ou generator de schelet",
  "item.minecraft.skeleton_horse_spawn_egg": "ou generator de cal schelet",
  "item.minecraft.slime_spawn_egg": "ou generator de mâzgă",
  "item.minecraft.spider_spawn_egg": "ou generator de păianjen",
  "item.minecraft.squid_spawn_egg": "ou generator de calmar",
  "item.minecraft.stray_spawn_egg": "ou generator de hoinar",
  "item.minecraft.strider_spawn_egg": "ou generator de umblător",
  "item.minecraft.trader_llama_spawn_egg": "ou generator de lama negustorului",
  "item.minecraft.tropical_fish_spawn_egg": "ou generator de pește tropical",
  "item.minecraft.turtle_spawn_egg": "ou generator de țestoasă",
  "item.minecraft.vex_spawn_egg": "ou generator de spirit",
  "item.minecraft.villager_spawn_egg": "ou generator de sătean",
  "item.minecraft.vindicator_spawn_egg": "ou generator de apărător",
  "item.minecraft.wandering_trader_spawn_egg": "ou generator de negustor ambulant",
  "item.minecraft.witch_spawn_egg": "ou generator de vrăjitoare",
  "item.minecraft.wither_skeleton_spawn_egg": "ou generator de schelet wither",
  "item.minecraft.wolf_spawn_egg": "ou generator de lup",
  "item.minecraft.zoglin_spawn_egg": "ou generator de zoglin",
  "item.minecraft.zombie_spawn_egg": "ou generator de zombi",
  "item.minecraft.zombie_horse_spawn_egg": "ou generator de cal zombi",
  "item.minecraft.zombie_villager_spawn_egg": "ou generator de sătean zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "ou generator de piglin zombificat",
  "item.minecraft.experience_bottle": "sticluță de experiență",
  "item.minecraft.fire_charge": "minge de foc",
  "item.minecraft.writable_book": "carte și condei",
  "item.minecraft.written_book": "carte scrisă",
  "item.minecraft.emerald": "smarald",
  "item.minecraft.item_frame": "ramă de obiect",
  "block.minecraft.flower_pot": "ghiveci de flori",
  "item.minecraft.carrot": "morcov",
  "item.minecraft.potato": "cartof",
  "item.minecraft.baked_potato": "cartof copt",
  "item.minecraft.poisonous_potato": "cartof otrăvitor",
  "item.minecraft.map": "hartă goală",
  "item.minecraft.golden_carrot": "morcov de aur",
  "block.minecraft.skeleton_skull": "craniu de schelet",
  "block.minecraft.wither_skeleton_skull": "craniu de schelet wither",
  "block.minecraft.player_head": "cap de jucător",
  "block.minecraft.zombie_head": "cap de zombi",
  "block.minecraft.creeper_head": "cap de creeper",
  "block.minecraft.dragon_head": "cap de dragon",
  "item.minecraft.carrot_on_a_stick": "morcov pe băț",
  "item.minecraft.warped_fungus_on_a_stick": "ciupercă deformată pe un băț",
  "item.minecraft.nether_star": "stea de nether",
  "item.minecraft.pumpkin_pie": "plăcintă cu dovleac",
  "item.minecraft.firework_rocket": "artificiu",
  "item.minecraft.firework_star": "stea de artificiu",
  "item.minecraft.enchanted_book": "carte fermecată",
  "item.minecraft.nether_brick": "cărămidă de nether",
  "item.minecraft.quartz": "cuarț de nether",
  "item.minecraft.tnt_minecart": "tnt în vagonet",
  "item.minecraft.hopper_minecart": "pâlnie în vagonet",
  "item.minecraft.prismarine_shard": "ciob de prismarin",
  "item.minecraft.prismarine_crystals": "cristale de prismarin",
  "item.minecraft.rabbit": "iepure crud",
  "item.minecraft.cooked_rabbit": "iepure fript",
  "item.minecraft.rabbit_stew": "tocană de iepure",
  "item.minecraft.rabbit_foot": "labă de iepure",
  "item.minecraft.rabbit_hide": "piele de iepure",
  "item.minecraft.armor_stand": "suport de armură",
  "item.minecraft.iron_horse_armor": "armură de cal din fier",
  "item.minecraft.golden_horse_armor": "armură de cal din aur",
  "item.minecraft.diamond_horse_armor": "armură de cal din diamant",
  "item.minecraft.leather_horse_armor": "armură de cal din piele",
  "item.minecraft.lead": "lesă",
  "item.minecraft.name_tag": "etichetă de nume",
  "item.minecraft.command_block_minecart": "bloc de comenzi în vagonet",
  "item.minecraft.mutton": "carne de oaie crudă",
  "item.minecraft.cooked_mutton": "carne de oaie friptă",
  "block.minecraft.white_banner": "stindard alb",
  "block.minecraft.orange_banner": "stindard portocaliu",
  "block.minecraft.magenta_banner": "stindard magenta",
  "block.minecraft.light_blue_banner": "stindard bleu",
  "block.minecraft.yellow_banner": "stindard galben",
  "block.minecraft.lime_banner": "stindard verde-deschis",
  "block.minecraft.pink_banner": "stindard roz",
  "block.minecraft.gray_banner": "stindard gri",
  "block.minecraft.light_gray_banner": "stindard gri-deschis",
  "block.minecraft.cyan_banner": "stindard turcoaz",
  "block.minecraft.purple_banner": "stindard violet",
  "block.minecraft.blue_banner": "stindard albastru",
  "block.minecraft.brown_banner": "stindard maro",
  "block.minecraft.green_banner": "stindard verde",
  "block.minecraft.red_banner": "stindard roșu",
  "block.minecraft.black_banner": "stindard negru",
  "item.minecraft.end_crystal": "cristal din end",
  "item.minecraft.chorus_fruit": "fruct coral",
  "item.minecraft.popped_chorus_fruit": "fruct coral spart",
  "item.minecraft.beetroot": "sfeclă",
  "item.minecraft.beetroot_seeds": "semințe de sfeclă",
  "item.minecraft.beetroot_soup": "supă de sfeclă",
  "item.minecraft.dragon_breath": "suflu de dragon",
  "item.minecraft.splash_potion": "poțiune de aruncat nefabricabilă□niciun efect",
  "item.minecraft.spectral_arrow": "săgeată spectrală",
  "item.minecraft.tipped_arrow": "săgeată impregnată nefabricabilă□niciun efect",
  "item.minecraft.lingering_potion": "poțiune persistentă nefabricabilă□niciun efect",
  "item.minecraft.shield": "scut",
  "item.minecraft.elytra": "elitre",
  "item.minecraft.spruce_boat": "barcă de molid",
  "item.minecraft.birch_boat": "barcă de mesteacăn",
  "item.minecraft.jungle_boat": "barcă de junglă",
  "item.minecraft.acacia_boat": "barcă de salcâm",
  "item.minecraft.dark_oak_boat": "barcă de stejar negru",
  "item.minecraft.totem_of_undying": "totem al nemuririi",
  "item.minecraft.shulker_shell": "carapace de shulker",
  "item.minecraft.iron_nugget": "pepită de fier",
  "item.minecraft.knowledge_book": "carte de cunoaștere",
  "item.minecraft.debug_stick": "băț de depanare",
  "item.minecraft.music_disc_13": "disc muzical□c418 - 13",
  "item.minecraft.music_disc_cat": "disc muzical□c418 - cat",
  "item.minecraft.music_disc_blocks": "disc muzical□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disc muzical□c418 - chirp",
  "item.minecraft.music_disc_far": "disc muzical□c418 - far",
  "item.minecraft.music_disc_mall": "disc muzical□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disc muzical□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disc muzical□c418 - stal",
  "item.minecraft.music_disc_strad": "disc muzical□c418 - strad",
  "item.minecraft.music_disc_ward": "disc muzical□c418 - ward",
  "item.minecraft.music_disc_11": "disc muzical□c418 - 11",
  "item.minecraft.music_disc_wait": "disc muzical□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disc muzical□lena raine - pigstep",
  "item.minecraft.trident": "trident□□în mâna principală:□+8 puncte de atac□-2.9 viteză de atac",
  "item.minecraft.phantom_membrane": "membrană de fantasmă",
  "item.minecraft.nautilus_shell": "cochilie de nautilus",
  "item.minecraft.heart_of_the_sea": "inima mării",
  "item.minecraft.crossbow": "arbaletă",
  "item.minecraft.suspicious_stew": "supă suspectă",
  "block.minecraft.loom": "război de țesut",
  "item.minecraft.flower_banner_pattern": "model pentru stindard□floare",
  "item.minecraft.creeper_banner_pattern": "model pentru stindard□creeper",
  "item.minecraft.skull_banner_pattern": "model pentru stindard□cap de mort",
  "item.minecraft.mojang_banner_pattern": "model pentru stindard□chestie",
  "item.minecraft.globe_banner_pattern": "model pentru stindard□glob",
  "item.minecraft.piglin_banner_pattern": "model pentru stindard□rât",
  "block.minecraft.composter": "compostor",
  "block.minecraft.barrel": "butoi",
  "block.minecraft.smoker": "afumătoare",
  "block.minecraft.blast_furnace": "furnal",
  "block.minecraft.cartography_table": "masă de cartografie",
  "block.minecraft.fletching_table": "masă de făcut săgeți",
  "block.minecraft.grindstone": "tocilă",
  "block.minecraft.lectern": "pupitru",
  "block.minecraft.smithing_table": "masă de fierărie",
  "block.minecraft.stonecutter": "tăietor de piatră",
  "block.minecraft.bell": "clopot",
  "block.minecraft.lantern": "felinar",
  "block.minecraft.soul_lantern": "felinar de suflete",
  "item.minecraft.sweet_berries": "fructe de pădure dulci",
  "block.minecraft.campfire": "foc de tabără",
  "block.minecraft.soul_campfire": "foc de tabără de suflete",
  "block.minecraft.shroomlight": "strălucipercă",
  "item.minecraft.honeycomb": "fagure",
  "block.minecraft.bee_nest": "cuib de albine",
  "block.minecraft.beehive": "stup de albine",
  "item.minecraft.honey_bottle": "sticlă cu miere",
  "block.minecraft.honey_block": "bloc de miere",
  "block.minecraft.honeycomb_block": "bloc de fagure",
  "block.minecraft.lodestone": "magnetită",
  "block.minecraft.netherite_block": "bloc de netherit",
  "block.minecraft.ancient_debris": "relicvă antică",
  "block.minecraft.target": "țintă",
  "block.minecraft.crying_obsidian": "obsidian plângător",
  "block.minecraft.blackstone": "piatră neagră",
  "block.minecraft.blackstone_slab": "lespede de piatră neagră",
  "block.minecraft.blackstone_stairs": "trepte de piatră neagră",
  "block.minecraft.gilded_blackstone": "piatră neagră aurită",
  "block.minecraft.polished_blackstone": "piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_slab": "lespede de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_stairs": "trepte de piatră neagră șlefuită",
  "block.minecraft.chiseled_polished_blackstone": "piatră neagră șlefuită sculptată",
  "block.minecraft.polished_blackstone_bricks": "cărămizi de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_brick_slab": "lespede de cărămizi de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_brick_stairs": "trepte de cărămizi de piatră neagră șlefuită",
  "block.minecraft.cracked_polished_blackstone_bricks": "cărămizi de piatră neagră șlefuită crăpate",
  "block.minecraft.respawn_anchor": "ancoră de reînviere",
}
export const ro_ro = items; 
